<template>
  <div class="outer-map-box">
    <div class="mapBox" ref="mapInfo" id="mapInfo"></div>

    <div class="mark-outer">
      <div class="mark-list">
        <div :class="['mark-item', markId == item.id ? 'active' : '']" v-for="(item,index) in mapDate" :key="index" @click="clickPoint(item)">{{item.name}}</div>
      </div>
    </div>
    <!-- <div class="mark-options">
            <div class="mark-title">中共浙江省“一大”纪念园</div>
            <div class="mark-second">地址：北京，北京，海淀区教育在线</div>
            <div class="mark-third">
                <div class="third-left">厦门软件职业技术学院（xiamen institute of software technology）是经福建省人民政府批准、</div>
                <div class="third-right">
                    <img src="../../assets/image/student/stepThree/bg.png" />
                </div>
            </div>
        </div> -->
  </div>
</template>

<script>
var img1 = require('../../assets/image/student/stepThree/mark.png');
var img2 = require('../../assets/image/student/stepThree/mark-active.png');

export default {
  name: "TianMap",
  props: {
    mapDate: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // this.mapDate: this.mapDate,
      mapTian: null,
      marker: null,
      markId: '',
      initZoom: 4,
    }
  },
  created () {

  },
  mounted () {
    let that = this;
    window.handleButtonClick = that.handleButtonClick;
    this.initTianMap()
    // 监听屏幕宽度和高度变化
    // window.addEventListener('resize', that.handleResize)
  },
  beforeDestroy () {
    // window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    resetMap () {
        this.markId = ''
      this.mapTian.clearOverLays() // 清除地图上所有覆盖物
      if(this.mapDate && this.mapDate[0].lng_lat_arr){
        this.mapTian.centerAndZoom(new window.T.LngLat(this.mapDate[0].lng_lat_arr[0],this.mapDate[0].lng_lat_arr[1]), this.initZoom);
      }
      this.initMapMarker()
    },
    // 右侧展馆列表点击事件
    clickPoint (item) {
        this.markId = item.id
       this[`markerObj${item.id}`].openInfoWindow(this[`markerInfoWin${item.id}`]);
    },
    handleButtonClick (item) {
      this.$emit("submitPoint", item)
    },
    // 初始化地图
    initTianMap() {
      this.mapTian = new window.T.Map('mapInfo');
      this.mapTian.maxZoom = 18;
      this.mapTian.centerAndZoom(new window.T.LngLat(116.360908,39.954235), this.initZoom);
      this.mapTian.enableDrag();
      this.initMapMarker()
    },
    // 初始化地图覆盖物
    initMapMarker(){
        // let points = [];
        this.mapDate.forEach(item=>{
            this.createMarkerBox(item)
            // points.push(new window.T.LngLat(item.lng_lat_arr[0], item.lng_lat_arr[1]));
        })
        //创建线对象
        // var line = new window.T.Polyline(points,{color:"#a82822", weight:3, opacity:1,lineStyle:'dashed'});
        //向地图上添加线
        // this.mapTian.addOverLay(line);
    },
    // 创建地图覆盖物及信息弹窗
    createMarkerBox(item){
        //创建图片对象
        var icon1 = new window.T.Icon({
            iconUrl: img1,
            iconSize: new window.T.Point(19, 27),
            iconAnchor: new window.T.Point(10, 25)
        });
        //创建图片对象
        let icon2 = new window.T.Icon({
            iconUrl: img2,
            iconSize: new window.T.Point(19, 27),
            iconAnchor: new window.T.Point(10, 25)
        });
        let that = this;
        //向地图上添加自定义标注
        var point = new window.T.LngLat(item.lng_lat_arr[0], item.lng_lat_arr[1]);
        var marker = new window.T.Marker(point, {icon: icon1});// 创建标注
        that.marker = marker
        that.mapTian.addOverLay(marker);
        let content = ` <div class="mark-options">
            <div class="mark-title">
                <div class="title-txt">${item.name}</div>
                 <div class="mark-button" onclick=handleButtonClick('${JSON.stringify({ id: item.id, url: item.url })}')>在线查看 ></div>
            </div>
           
            <div class="mark-second">地址：${item.address}</div>
            <div class="mark-third">
                <div class="third-left">${item.intro}</div>
                <div class="third-right"><img src="${item.cover}" /></div>
            </div>
        </div>`
        var markerInfoWin = new window.T.InfoWindow(content, {
            autoPan:  true // 是否开启信息窗口打开时地图自动移动（默认关闭）。
        });
        // markerInfoWin.setContent(` <div class="mark-options">
        //     <div class="mark-title">
        //         <div class="title-txt">${item.name}</div>
        //          <div class="mark-button" onclick=handleButtonClick('${JSON.stringify({ id: item.id, url: item.url })}')>在线查看 ></div>
        //     </div>
           
        //     <div class="mark-second">地址：${item.address}</div>
        //     <div class="mark-third">
        //         <div class="third-left">${item.intro}</div>
        //         <div class="third-right"><img src="${item.cover}" /></div>
        //     </div>
        // </div>`);
        marker.addEventListener("click", function () {
            marker.openInfoWindow(markerInfoWin);
        });
        markerInfoWin.addEventListener("open", function () {
            // that.mapTian.centerAndZoom(new window.T.LngLat(item.lng_lat_arr[0],item.lng_lat_arr[1]), that.initZoom);
            marker.setIcon(icon2)
            that.markId = item.id
        });
        markerInfoWin.addEventListener("close", function () {
            marker.setIcon(icon1)
            that.markId = ''
        });
        that[`markerInfoWin${item.id}`] =  markerInfoWin
        that[`markerObj${item.id}`] = marker
        
    },
  }
}
</script>

<style scoped lang="less">
/deep/ #mapInfo > div:last-child {
    position: absolute !important;
    top: unset !important;
    bottom: 0 !important;
    left: 67% !important;
    transform: translate(-50%) !important;
    width: max-content !important;
    max-width: 80%;
}
.outer-map-box {
    width: 100%;
    height: 420px;
}
.mapBox {
    width: calc(100% - 305px);
    height: 100%;
    display: inline-block;
    background: url('../../assets/image/student/stepThree/mapbg.png') no-repeat
        center;
    background-size: cover;
}
.mark-outer {
    display: inline-block;
    vertical-align: top;
    width: 305px;
    height: 100%;
    background: url('../../assets/image/student/stepThree/address-bg.png')
        no-repeat center;
    background-size: 100% 100%;
    padding: 10px 0;
    overflow: hidden;
}
.mark-list {
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    .mark-item {
        width: 260px;
        text-align: center;
        background: transparent;
        border-radius: 4px;
        font-weight: 400;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        padding: 5px 10px;
        margin: 0 auto 10px;
        &.active,
        &:hover {
            background: #a82822;
        }
    }
    &::-webkit-scrollbar {
        width: 3px;
        height: 3px;
    }

    &::-webkit-scrollbar-track-piece {
        background: #b57f77;
    }

    &::-webkit-scrollbar-thumb {
        background: #ffebd3;
        border-radius: 6px;
    }
}


/deep/ .mark-options {
  max-width: 550px;
//   max-height: 170px;
  background: #ffffff;
  padding: 15px 0 0;
overflow: hidden;
position: relative;


  .mark-title {
    font-weight: bold;
    font-size: 16px;
    color: #2f2626;
    line-height: 22px;
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
    .title-txt {
        flex: 1;
        // display: inline-block;
    }
    .mark-button {
        cursor: pointer;
        font-size: 16px;
        display: block;
        flex:0 90px;
        text-align: right;
        color: #892018;
    }
  }
  .mark-second {
    font-weight: bold;
    font-size: 12px;
    color: #ca835c;
    line-height: 20px;
  }
  .mark-third {
    padding-top: 10px;
    display: flex;
    .third-left {
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 17px;
      white-space: pre-wrap;
      margin-right: 10px;
    }
    .third-right {
      width: 128px;
      img {
        width: 128px;
        height: auto;
      }
    }
  }
}
/deep/ .tdt-pane {
    z-index: 80;
}
/deep/ .tdt-infowindow-content {
    width: max-content !important;
    height: max-content !important;
}
@media screen and (max-width: 1800px) {
    .outer-map-box {
        height: 317px;
    }
    .mapBox {
        width: calc(100% - 229px);
        height: 100%;
    }
    .mark-outer {
        width: 229px;
        height: 100%;
    }
    .mark-item {
        width: 200px !important;
        padding: 5px !important;
    }
}
</style>